// Grade values a student can be assigned — matches the CHECK constraint on
// et_live.student.grade (ai-tutor migration 0055_add_student_grade).
export const ALL_GRADES = [
  "K",
  "1",
  "2",
  "3",
  "4",
  "5",
  "6",
  "7",
  "8",
  "HS",
] as const;

export type Grade = (typeof ALL_GRADES)[number];

export const isValidGrade = (value: string): value is Grade =>
  (ALL_GRADES as readonly string[]).includes(value);
